import script from "./OperatorApplicationConfigChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationConfigChat.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationConfigChat.vue?vue&type=style&index=0&id=46a057b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a057b8"]])

export default __exports__